import type { I18nKey } from './en';

/**
 * Hindi — partial starter translation; missing keys fall back to English.
 * Layouts must never assume English string lengths.
 */
export const hi: Partial<Record<I18nKey, string>> = {
  'app.tagline': 'आपकी कुंडली। आपका Ally। आपके लोग।',
  'tabs.ally': 'Ally',
  'tabs.charts': 'कुंडली',
  'tabs.messages': 'संदेश',
  'tabs.profile': 'प्रोफ़ाइल',
  'onb.name': 'Ally आपको किस नाम से बुलाए?',
  'onb.dob': 'जन्म तिथि',
  'onb.place': 'जन्म स्थान',
  'onb.timeStatus': 'आपका जन्म समय',
  'onb.time.exact': 'मुझे अपना सटीक जन्म समय पता है',
  'onb.time.approx': 'मुझे अनुमानित समय या सीमा पता है',
  'onb.time.unknown': 'मुझे अपना जन्म समय नहीं पता',
  'onb.time.unknown.note':
    'अनुमान लगाने की ज़रूरत नहीं। हम पूरे दिन के लिए जो विश्वसनीय है वही निकालेंगे — लग्न और भाव तब तक खाली रहेंगे जब तक समय सीमित न हो।',
  'onb.language': 'पसंदीदा भाषा',
  'onb.ageConfirm': 'मैं पुष्टि करता/करती हूँ कि मेरी उम्र 18+ है',
  'chart.stable': 'आपकी समय-सीमा में स्थिर',
  'chart.possible': 'सटीक समय पर निर्भर संभावनाएँ',
  'chart.unavailable': 'समय सीमित होने तक अनुपलब्ध',
  'chart.tab.jyotish': 'ज्योतिष',
  'chart.tab.western': 'पाश्चात्य',
  'chart.tab.combined': 'संयुक्त',
  'ally.placeholder': 'अपनी कुंडली, पैटर्न, लोगों के बारे में पूछें…',
  'memory.title': 'Ally मेरे बारे में क्या जानता है',
  'msg.title': 'संदेश',
  'profile.title': 'प्रोफ़ाइल',
  'common.continue': 'आगे बढ़ें',
  'common.back': 'वापस',
  'common.save': 'सहेजें',
  'common.cancel': 'रद्द करें',
};
